export default __webpack_public_path__ + "assets/icons/apply_phone.25fba39a.svg";